import { Button, Popover } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import SingleTextField from "@saleor/components/SingleTextField";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React, { useState } from "react";

const useStyles = makeStyles(
  () => ({
    actionRow: {
      display: "flex",
      alignItems: "center",
      gap: "2rem",
      marginTop: "8px",
      justifyContent: "space-between",
      "& .MuiButton-root": {
        width: "100%",
        height: 32
      },
      p: { padding: "0px" }
    },
    container: {
      width: "320px"
    },
    okBtn: {
      background: "#009FB8",
      width: "30px !important",
      marginTop: "0px"
    },
    hintTxt: {
      margin: "0px",
      color: "#999999"
    },
    noPad: {
      padding: "0px"
    },

    root: {
      "& .MuiPopover-paper": {
        padding: "1.4rem",
        borderRadius: 16,
        width: 320
      }
    },
    titlePopover: {
      marginBottom: "2.4rem"
    }
  }),
  { name: "POItemPopover" }
);
const CustomPopover = ({
  openPOItem,
  anchorRef,
  setOpenPOItem,
  classesLocal,
  handleOnApplyAllPOItem,
  formikHeader,
  row,
  col
}) => {
  const [value, setValue] = useState<string>(
    row[col.id] ?? formikHeader.values.poNumber
  );
  const maxLengthInput = 35;
  const handleChangeInput = value => {
    setValue(value.target.value);
  };
  return (
    <Popover
      open={openPOItem}
      anchorEl={anchorRef.current}
      onClose={() => setOpenPOItem(false)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
      className={classesLocal.root}
    >
      <SingleTextField
        onChange={handleChangeInput}
        value={value}
        maxLengthProps={maxLengthInput}
        id={`lines[${row?.indexNumber}].${col.id}Field`}
      />

      <div className={classesLocal.actionRow}>
        <p className={classesLocal.hintTxt}>
          {" "}
          {`${value?.length}/${maxLengthInput}`}
        </p>

        <Button
          id={`lines[${row?.indexNumber}].applyAllPOItem`}
          variant={"contained"}
          className={classesLocal.okBtn}
          onClick={() => handleOnApplyAllPOItem(value)}
        >
          <MyTypography variant={"body3"}>Ok</MyTypography>
        </Button>
      </div>
    </Popover>
  );
};
const PoItemPopover = ({ row, col, classes, handleChange, formikHeader }) => {
  const classesLocal = useStyles();

  const [openPOItem, setOpenPOItem] = useState<boolean>(false);

  const anchorRef = React.useRef<HTMLButtonElement>(null);

  const handleOnApplyAllPOItem = value => {
    const name = `lines[${row?.indexNumber}].${col.id}`;
    handleChange({ target: { name, value } });
    setOpenPOItem(false);
  };

  return (
    <div>
      <MyTypography variant={"subtitle3"}>
        {row.label}
        <Button
          id={`lines[${row?.indexNumber}].openPOItem`}
          onClick={() => setOpenPOItem(true)}
          ref={anchorRef}
          className={classesLocal.noPad}
        >
          <SingleTextField
            id={`lines[${row?.indexNumber}].${col.id}Field`}
            name={`lines[${row?.indexNumber}].${col.id}`}
            value={row[col.id] ?? formikHeader.values.poNumber}
            disabled={false}
            onChange={handleChange}
            className={classNames(classes.commonText)}
            readOnly
          />
        </Button>

        {openPOItem && (
          <CustomPopover
            {...{
              openPOItem,
              anchorRef,
              setOpenPOItem,
              classesLocal,
              handleOnApplyAllPOItem,
              formikHeader,
              row,
              col
            }}
          />
        )}
      </MyTypography>
    </div>
  );
};

export default PoItemPopover;
